import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

const navLinks = [
  { label: "Inicio", path: "/" },
  { label: "Servicios", path: "/servicios" },
  { label: "Sobre el Doctor", path: "/sobre-el-doctor" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";
  const isTransparent = isHome && !scrolled;

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isTransparent
            ? "bg-transparent"
            : "bg-white shadow-sm border-b border-slate-100"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-[70px] flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/b33c731a0a8a80a76070c43759aaf839.png"
                alt="Clínica Dr. Erick Tejada"
                className="w-10 h-10 object-contain"
              />
            </div>
            <div>
              <p
                className={`font-semibold text-sm leading-tight transition-colors ${
                  isTransparent ? "text-white" : "text-slate-800"
                }`}
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                Dr. Erick Tejada
              </p>
              <p
                className={`text-xs transition-colors ${
                  isTransparent ? "text-white/80" : "text-teal-600"
                }`}
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                Colposcopia &amp; Ginecología
              </p>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? isTransparent
                      ? "text-white border-b-2 border-white pb-0.5"
                      : "text-teal-600 border-b-2 border-teal-600 pb-0.5"
                    : isTransparent
                    ? "text-white/90 hover:text-white"
                    : "text-slate-600 hover:text-teal-600"
                }`}
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center">
            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-whatsapp-line text-base"></i>
              Agendar Cita
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 p-2 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span
              className={`block w-6 h-0.5 transition-all duration-300 ${
                isTransparent ? "bg-white" : "bg-slate-800"
              } ${menuOpen ? "rotate-45 translate-y-2" : ""}`}
            />
            <span
              className={`block w-6 h-0.5 transition-all duration-300 ${
                isTransparent ? "bg-white" : "bg-slate-800"
              } ${menuOpen ? "opacity-0" : ""}`}
            />
            <span
              className={`block w-6 h-0.5 transition-all duration-300 ${
                isTransparent ? "bg-white" : "bg-slate-800"
              } ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`}
            />
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden bg-white border-t border-slate-100 overflow-hidden transition-all duration-300 ${
            menuOpen ? "max-h-96 py-4" : "max-h-0"
          }`}
        >
          <div className="px-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-3 px-3 rounded-lg transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? "bg-teal-50 text-teal-600"
                    : "text-slate-700 hover:bg-slate-50"
                }`}
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {link.label}
              </Link>
            ))}
            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="mt-3 flex items-center justify-center gap-2 bg-teal-600 text-white text-sm font-semibold px-5 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-whatsapp-line text-base"></i>
              Agendar Cita por WhatsApp
            </a>
          </div>
        </div>
      </nav>
    </>
  );
}
